export default "/status-error.d6d9f36dcf3ca55d44f67c56502e6d4f.svg";